import { CarouselModule } from '@anecdotes/design-system/carousel';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import {
  ActionMenuButtonComponent,
  ColoredDropdownMenuComponent,
  TabsComponent,
  DropdownButtonComponent,
  DropdownSearchInputComponent,
  MultiDropdownControlComponent,
  DropdownControlComponent,
  ColoredDropdownControlComponent,
  ThreeDotsMenuComponent,
  LabelsDropdownComponent,
  ColorPickerComponent,
  VerticalTabsComponent,
} from './components';
import { DropdownAtomsModule } from './dropdown-atoms.module';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import { FormControlsModule } from '@anecdotes/design-system/form-controls';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { DropdownOptionWithSubmenuComponent } from './components/dropdown-option-with-submenu/dropdown-option-with-submenu.component';
import { UtilsModule } from '@anecdotes/design-system/utils';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { LoadersModule } from '@anecdotes/design-system/loaders';

@NgModule({
  declarations: [
    ThreeDotsMenuComponent,
    ActionMenuButtonComponent,
    ColoredDropdownMenuComponent,
    TabsComponent,
    VerticalTabsComponent,
    DropdownButtonComponent,
    DropdownSearchInputComponent,
    MultiDropdownControlComponent,
    DropdownControlComponent,
    ColoredDropdownControlComponent,
    DropdownOptionWithSubmenuComponent,
    LabelsDropdownComponent,
    ColorPickerComponent
  ],
  exports: [
    ThreeDotsMenuComponent,
    ActionMenuButtonComponent,
    ColoredDropdownMenuComponent,
    TabsComponent,
    VerticalTabsComponent,
    DropdownButtonComponent,
    DropdownSearchInputComponent,
    MultiDropdownControlComponent,
    DropdownControlComponent,
    ColoredDropdownControlComponent,
    LabelsDropdownComponent,
    ColorPickerComponent
  ],
  imports: [
    LoadersModule,
    CommonModule,
    DropdownAtomsModule,
    MatMenuModule,
    SvgIconsModule,
    TranslateModule,
    NgbTooltipModule,
    ButtonsModule,
    RouterModule,
    DirectivesModule,
    FormControlsModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayModule,
    UtilsModule,
    PerfectScrollbarModule,
    CarouselModule,
    VirtualScrollerModule,
  ],
})
export class DropdownMenuModule {}
